// @flow
import FontAwesome from 'react-fontawesome';
import React, { Component } from 'react';
import { NavItem, Nav } from 'react-bootstrap';

import locale from '../../../locales/index';

import Header from '../Header/Header';

class MenuHeader extends Component<{
  active?: string,
}> {
  static defaultProps = {
    active: '',
  }

  isActive(page: string): boolean {
    return (page === this.props.active);
  }

  render(): React.Node {
    const adminType = window.location.href.split('#')[1].split('/')[1];

    const menuItems = [
      <NavItem key={1} active={this.isActive('users')} eventKey={1} href={`#/${adminType}`}><FontAwesome name="list" /> {locale.users}</NavItem>,
      <NavItem key={2} active={this.isActive('medication')} eventKey={2} href={`#/${adminType}/medication`}><FontAwesome name="medkit" /> {locale.medication}</NavItem>,
    ];

    if (adminType === 'su') {
      menuItems.push(
        <NavItem key={3} active={this.isActive('admins')} eventKey={3} href={`#/${adminType}/admins`}><FontAwesome name="user-circle-o" /> {locale.admins}</NavItem>,
      );
    }

    return (
      <Header>
        <Nav>
          {menuItems}
        </Nav>
      </Header>
    );
  }
}

export default MenuHeader;



// WEBPACK FOOTER //
// ./src/scenes/components/MenuHeader/MenuHeader.js